import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
// icons
import { FaSearch } from 'react-icons/fa';
import { FaXmark } from "react-icons/fa6";
// components
import SearchBar from 'components/navbar/SearchBar';
import SearchBarDesktop from 'components/navbar/SearchBarDesktop';
import ProductBarDesktop from 'components/navbar/ProductBarDesktop';
import LogoComponent from 'components/navbar/LogoComponent';

const SearchBarMenu = ({
  showSearchBar,
  isDesktop,
  isSticky,
  isScroll = false,
  secondaryImage,
  showMiniSearchBar,
  setShowMiniSearchBar }) => {
  const headerRef = useRef();
  return (
    <>
      {!isScroll ? <div
        ref={headerRef}
        id="search-bar"
        className={`container-full border-none`}
        style={{ display: !isSticky || showSearchBar ? 'block' : 'none' }}
      >
        {/* MENU BUSQUEDA < 992 */}
        <div className="mobile-look container-full pb-1 mb-1 border-none">
          <Row className="header__container">
            <Col className="header__search mobile">
              <SearchBar isDesktop={isDesktop} />
            </Col>
          </Row>
        </div>

        {/* MENU BUSQUEDA >= 992 */}
        <Container
          className={`desktop-look container-fluid container-responsive px-0 pb-1 mb-1 ${!isDesktop ? 'd-none' : 'd-block'
            }`}
        >
          <Row className="header__container pt-3">
            {/* IMAGEN >= 992*/}
            <LogoComponent
              isDesktop={true}
              isSticky={isSticky}
              secondaryImage={secondaryImage} />

            {/* BUSQUEDA > 992 */}
            <SearchBarDesktop isDesktop={isDesktop} secondaryImage={secondaryImage} />

            {/* BOTON PRODUCTOS > 992 */}
            <ProductBarDesktop />
          </Row>
        </Container>
      </div> :
        <span
          id="desktop-simple-search-btn"
          className={` ${isSticky ? 'd-block navbar-item-log' : 'd-none'}`}
        >
          {!showMiniSearchBar ? (
            <FaSearch
              className={`icon-input fas search-scroll`}
              title="Búsqueda"
              onClick={() => setShowMiniSearchBar(!showMiniSearchBar)}
            />) :
            <FaXmark
              className={`icon-input fas search-scroll`}
              title="Close"
              onClick={() => setShowMiniSearchBar(!showMiniSearchBar)}
            />
          }
          <div
            type="text"
            placeholder=""
            title="Barra Búsqueda"
            className={`show-miniBar-search ${showMiniSearchBar ? 'animate' : ''}`}
            style={{ display: showMiniSearchBar ? 'block' : 'none' }}
          >
            {/* BARRA BUSQUEDA TAMAÑO DESKTOP + SCROLL */}
            <SearchBar isDesktop={false} />
          </div>
        </span>}
    </>
  );
};

SearchBarMenu.propTypes = {
  showSearchBar: PropTypes.bool,
  isDesktop: PropTypes.bool,
  isSticky: PropTypes.bool,
  isScroll: PropTypes.bool,
  secondaryImage: PropTypes.bool,
  showMiniSearchBar: PropTypes.bool,
  setShowMiniSearchBar: PropTypes.func
};

export default SearchBarMenu;
